import React from 'react';
import { hashClass } from '../../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../../context';
/**
 * Menu Link Component
 * @param children {string} Menu Link Text Content
 * @param arrow {boolean} Adding Right Arrow For Menu Link
 * @param onClick {Function} onClick Event
 */
const MenuLink = ({ children, className, arrow, onClick, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx(arrow && 'with-arrow', className));
    return (React.createElement("a", { "data-testid": testId, onClick: onClick, className: classes, ...others }, children));
};
export default MenuLink;
//# sourceMappingURL=MenuLink.js.map